"use strict";

import axios from "axios";
import { ElMessage } from "element-plus";
import router from "@/router";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
export default function(app) {


    let config = {
        // baseURL: "http://localhost",
        baseURL: "http://81.70.165.210:8110",
        timeout: 60 * 1000, // Timeout,

        // headers: {
        //     Authorization: `Bearer ${token}`,
        // }
        // withCredentials: true, // Check cross-site Access-Control
    };

    const _axios = axios.create(config);

    _axios.interceptors.request.use(config => {
        let token = app.config.globalProperties.$cookie.get("accessToken")
        console.log('请求开始');
        console.log(config);
        if (config.url.indexOf('token') < 0) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        console.log('请求完成');
        return config;
    }, err => {
        console.log("a2........a2")
        console.log(err)
        return err;
    });

    _axios.interceptors.response.use(config => {
        console.log("响应成功")
        console.log(config);
        // ElMessage.success('操作成功');
        if (config.data.status === 'FORBIDDEN') {
            console.log(config.config.url)
                // 生成方案直接弹出
            if (config.config.url.indexOf('solution') >= 0 || config.config.url.indexOf('username') >= 0) {
                return "FORBIDDEN"
            }
            router.push({
                name: "登录"
            });
        }
        if (config.data.status === 'SUCCESS') {
            ElMessage.success('操作成功');
        }
        if (config.data.status === 'MESSAGE') {
            ElMessage.message(config.data.message);
        }
        if (config.data.status === 'WARNING') { ElMessage.warning(config.data.message) }
        if (config.data.status === 'ERROR') {
            ElMessage.error(config.data.message);
            return null;
        }
        return config.data.data;
    }, err => {
        console.log("响应失败")
        console.log(err);
        if (err.response) {
            switch (err.response.status) {
                case 401:
                    router.push({
                        name: "登录"
                    });
                    break;
                case 404:
                    ElMessage.error("好像服务器开小差了");
                    break;
                case 500:
                    ElMessage.error("您的请求我好像还不会处理，不过我很好学喔");
                    break;
                default:
                    ElMessage.error("好像服务器开小差了");
            }
        }
        if (!err.response) {

            ElMessage.error("好像网络出问题了");
        }
        return Promise.reject(err);
    });
    app.config.globalProperties.$http = _axios;
}